import { atom } from '@reatom/core';
import { withLocalStorage } from '@reatom/persist-web-storage';

export const fcmTokenAtom = atom<string | null>(null, 'fcmToken').pipe(
  withLocalStorage('fcmToken'),
);
